import { post } from 'store/request';

// 获取列表
const getOrderSquareList = (params) => {
  return post('/demand/get_demand_list/', params, 'v2');
  // return Promise.resolve({
  //   code: 0,
  //   data: {
  //     conf: {
  //       totalCount: 100,
  //     },
  //     // items: [{ id: 1 }, { id: 2 }],
  //     items: [
  //       {
  //         id: 30,
  //         type: 1,
  //         target: 2,
  //         content: 'content',
  //         budget: 10000,
  //         company_name: 'companyName',
  //         company_industry: 22,
  //         tender_status: 2, // 参与状态
  //         if_recommend: 0, // 是否运营推荐推荐，0为未推荐1为已推荐
  //       },
  //     ],
  //   },
  // });
};

// 上传合同
const uploadContract = (params) => {
  return post(
    '/demand/upload/',
    {
      ...params,
      type: 3, // 文本上传的类型的枚举值：1 运营上传需求补充资料 2服务商上传资料 3合同
    },
    'v2'
  );
};

// 上传资料
const uploadUpdateFile = (params) => {
  return post(
    '/demand/upload/',
    {
      ...params,
      type: 2, // 文本上传的类型的枚举值：1 运营上传需求补充资料 2服务商上传资料 3合同
    },
    'v2'
  );
};

const join = (params) => {
  return post(`/demand/participate_tender/${params.id}`, {}, 'v2');
};

const unJoin = (params) => {
  return post(`/demand/cancel_tender/${params.id}`, {}, 'v2');
};

const choose = (params) => {
  return post(`/demand/confirm_tender_agency/${params.id}`, {}, 'v2');
};

const unChoose = (params) => {
  return post(`/demand/cancel_tender_agency/${params.id}`, {}, 'v2');
};

export default {
  getOrderSquareList,
  uploadContract,
  uploadUpdateFile,
  join,
  unJoin,
  choose,
  unChoose,
};
